import PropTypes from 'prop-types'
import { Lock } from 'lucide-react'

// Shown next to an RO when CCC sent this estimate locked; save/exit (preliminary) versions show nothing.
export const EstimateLockIcon = ({ locked, className = '' }) => {
  if (!locked) return null
  return (
    <span
      data-testid='estimate-locked'
      title='Estimate locked in CCC'
      aria-label='Estimate locked in CCC'
      role='img'
      className={`inline-flex items-center text-[#64748B] ${className}`}
    >
      <Lock className='h-3.5 w-3.5' aria-hidden='true' />
    </span>
  )
}

EstimateLockIcon.propTypes = {
  locked: PropTypes.bool,
  className: PropTypes.string
}
